import type { ReactNode } from 'react'

export type TagItem = string | {
  label: string
  slug?: string
}

type PageSectionProps = {
  children: ReactNode
  as?: 'section' | 'article'
  size?: 'narrow' | 'article' | 'wide'
  align?: 'start' | 'center'
  className?: string
  ariaLabel?: string
}

export const PageSection = ({
  children,
  as: Component = 'section',
  size = 'narrow',
  align = 'start',
  className = '',
  ariaLabel,
}: PageSectionProps) => (
  <Component
    className={`page-section page-section--${size} page-section--${align} ${className}`}
    aria-label={ariaLabel}
  >
    {children}
  </Component>
)

export const DisplayHeading = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <h1 className={`display-heading ${className}`}>{children}</h1>
)

export const LeadText = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <p className={`lead-text ${className}`}>{children}</p>
)

export const Tags = ({ tags, className = '' }: { tags: TagItem[]; className?: string }) => (
  <div className={`tag-list ${className}`} aria-label="Tags">
    {tags.map((tag) => {
      const label = typeof tag === 'string' ? tag : tag.label
      const key = typeof tag === 'string' ? tag : tag.slug ?? tag.label

      return (
        <span key={key} className="tag-pill">
          {label}
        </span>
      )
    })}
  </div>
)

export const DateText = ({ date }: { date: string }) => (
  <time className="date-text" dateTime={date}>
    {new Intl.DateTimeFormat('en', { month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(date))}
  </time>
)
